/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_RestartInputs */

const en_us2_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart now`)
};

const pt_br2_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar agora`)
};

const es_419_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar ahora`)
};

const pt_pt2_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar agora`)
};

const fr_fr2_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redémarrer`)
};

const de_de2_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt neu starten`)
};

const it_it2_profile_update_restart = /** @type {(inputs: Profile_Update_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riavvia ora`)
};

/**
* | output |
* | --- |
* | "Restart now" |
*
* @param {Profile_Update_RestartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_restart = /** @type {((inputs?: Profile_Update_RestartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_RestartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_restart(inputs)
	if (locale === "es-419") return es_419_profile_update_restart(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_restart(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_restart(inputs)
	if (locale === "de-DE") return de_de2_profile_update_restart(inputs)
	if (locale === "it-IT") return it_it2_profile_update_restart(inputs)
	return en_us2_profile_update_restart(inputs)
});
export { profile_update_restart as "profile.update_restart" }